import PricingFormSection from "../../components/pricing-page-components/pricing-form/PricingFormSection.tsx";
import {MessageSubjectEnum} from "../../enum/message/MessageSubjectEnum.ts";
import {ConferenceFormInputsConfig} from "../../configs/pricing-page/pricingFormInputsConfig.ts";
import Advantages from "../../components/building-online-page-components/advantages/Advantages.tsx";
import {PricingAdvantagesCardsConfig} from "../../configs/pricing-page/pricingAdvantagesCards.ts";
import {PricingFormPageEnum} from "../../enum/pricing-form-page/pricingFormPageEnum.ts";
import useAsyncEffect from "use-async-effect";
import i18n from "i18next";
import {Language} from "../../@types/generics.tsx";

const ConferencePage = () => {

    useAsyncEffect(async () => {
        await i18n.changeLanguage(Language.LT);
    }, []);

    return (
        <>
            <PricingFormSection heading={'need_brave_to_grow'}
                                description={'more_conversion_and_growth'}
                                subject={MessageSubjectEnum.SUBJECT_CONFERENCE}
                                page={PricingFormPageEnum.CONFERENCE_PAGE}
                                config={ConferenceFormInputsConfig} />
            <Advantages className={'opy-bg-gray'} heading={null} advantages={PricingAdvantagesCardsConfig} />
        </>
    )
}

export default ConferencePage;
